export default "/kiban/_next/static/images/25_8L_2-4-2_withBH_staggered-eb9d79a68083d5fea47a80bcc230c224.png";